module.exports = __webpack_public_path__ + "img/ic24Loaction.ac71222e.svg";